import { useAppSelector } from '../../redux/hooks'
import { InstructorProfileData } from '../../server/types'
import './style.scss'

interface InstructorProfileRatingProps {
	profileData: InstructorProfileData
}

function InstructorProfileRating({profileData}: InstructorProfileRatingProps) {

	const reviews1Count: number = useAppSelector((state) => state.instructor.reviews1StarCount)
	const reviews2Count: number = useAppSelector((state) => state.instructor.reviews2StarCount)
	const reviews3Count: number = useAppSelector((state) => state.instructor.reviews3StarCount)
	const reviews4Count: number = useAppSelector((state) => state.instructor.reviews4StarCount)
	const reviews5Count: number = useAppSelector((state) => state.instructor.reviews5StarCount)

	const getRatingPercentage = (index: number) => {
		// if (index == 0) {
		// 	return profileData?.rating_overall ? (Number(profileData.rating_overall) / 5) * 100 : 0
		// } else if (index == 1) {
		// 	return profileData?.rating_analysis ? (Number(profileData.rating_analysis) / 5) * 100 : 0
		// } else if (index == 2) {
		// 	return profileData?.rating_communication ? (Number(profileData.rating_communication) / 5) * 100 : 0
		// } else if (index == 3) {
		// 	return profileData?.rating_quick_replies ? (Number(profileData.rating_quick_replies) / 5) * 100 : 0
		// } else if (index == 4) {
		// 	return profileData?.rating_encouragement ? (Number(profileData.rating_encouragement) / 5) * 100 : 0
		// }
		const totalNumberOfReviews: number = reviews5Count + reviews4Count + reviews3Count + reviews2Count + reviews1Count
		if (index == 0) {
			return (reviews5Count / Number(totalNumberOfReviews)) * 100
		} else if (index == 1) {
			return (reviews4Count / Number(totalNumberOfReviews)) * 100
		} else if (index == 2) {
			return (reviews3Count / Number(totalNumberOfReviews)) * 100
		} else if (index == 3) {
			return (reviews2Count / Number(totalNumberOfReviews)) * 100
		} else if (index == 4) {
			return (reviews1Count / Number(totalNumberOfReviews)) * 100
		}
		return 0
	}

	return (
		<div className='section-content'>
			<div className='instructor-profile-rating-section'>
				<div className='instructor-profile-rating-card'>
					<div className='instructor-profile-rating-card-list-wrap'>
						<div className='instructor-profile-rating-card-list-title'>Overall Rating</div>
						{
							[...Array(5)].map((_, index) => 
								<div 
									className='instructor-profile-rating-card-list-bar-wrap'
									key={`RatingBar${index}`}
								>
									<div className='instructor-profile-rating-card-list-bar-number'>{5 - index}</div>
									<div className='instructor-profile-rating-card-list-bar-blank'>
										<div 
											className='instructor-profile-rating-card-list-bar-colour'
											style={{width: `${getRatingPercentage(index)}%`}}
										/>
									</div>
								</div>
							)
						}
						{/* <div className='instructor-profile-rating-card-list-bar-wrap'>
							<div className='instructor-profile-rating-card-list-bar-number'>5</div>
							<div className='instructor-profile-rating-card-list-bar-blank'>
								<div 
									className='instructor-profile-rating-card-list-bar-colour'
									style={{width: `${Math.random() * 100}%`}}
								/>
							</div>
						</div> */}
					</div>
				</div>
				{/* {profileData.rating_analysis && */}
					<div className='instructor-profile-rating-card'>
						<div className='instructor-profile-rating-card-rating-wrap'>
							<div className='instructor-profile-rating-card-rating-title'>Analysis</div>
							<div className='instructor-profile-rating-card-rating-value'>{profileData.rating_analysis ? profileData.rating_analysis : '?'}</div>
							<img
								className='instructor-profile-rating-card-rating-icon'
								alt='Analysis'
								src='/imgs/icons/ratings/icon-rating-analysis.svg'
							/>
						</div>
					</div>
				{/* }
				{profileData.rating_communication && */}
					<div className='instructor-profile-rating-card'>
						<div className='instructor-profile-rating-card-rating-wrap'>
							<div className='instructor-profile-rating-card-rating-title'>Communication</div>
							<div className='instructor-profile-rating-card-rating-value'>{profileData.rating_communication ? profileData.rating_communication : '?'}</div>
							<img
								className='instructor-profile-rating-card-rating-icon'
								alt='Analysis'
								src='/imgs/icons/ratings/icon-rating-communication.svg'
							/>
						</div>
					</div>
				{/* }
				{profileData.rating_quick_replies && */}
					<div className='instructor-profile-rating-card'>
						<div className='instructor-profile-rating-card-rating-wrap'>
							<div className='instructor-profile-rating-card-rating-title'>Quick Replies</div>
							<div className='instructor-profile-rating-card-rating-value'>{profileData.rating_quick_replies ? profileData.rating_quick_replies : '?'}</div>
							<img
								className='instructor-profile-rating-card-rating-icon'
								alt='Analysis'
								src='/imgs/icons/ratings/icon-rating-quick-replies.svg'
							/>
						</div>
					</div>
				{/* }
				{profileData.rating_encouragement && */}
					<div className='instructor-profile-rating-card'>
						<div className='instructor-profile-rating-card-rating-wrap'>
							<div className='instructor-profile-rating-card-rating-title'>Encouragement</div>
							<div className='instructor-profile-rating-card-rating-value'>{profileData.rating_encouragement ? profileData.rating_encouragement : '?'}</div>
							<img
								className='instructor-profile-rating-card-rating-icon'
								alt='Analysis'
								src='/imgs/icons/ratings/icon-rating-encouragement.svg'
							/>
						</div>
					</div>
				{/* } */}
			</div>
		</div>
	)
}

export default InstructorProfileRating